/* =========================================
   State Module - Application State Management
   ========================================= */

import type { AdminUser, ResidentUser } from '../features/auth/auth.types.js';
import type { Bill } from '../features/bills/bills.types.js';
import type { Apartment } from '../features/apartments/apartments.types.js';

interface AppStateShape {
    currentUser: AdminUser | ResidentUser | null;
    currentPage: string;
    currentSection: string;
    currentYear: number;
    currentTaskFilter: string;
    bills: Bill[];
    dues: Record<number, Record<number, Record<number, boolean>>>;
    transactions: any[];
    maintenance: any[];
    tasks: any[];
    apartments: Apartment[];
    decisions: any[];
    settings: Record<string, any>;
    charts: Record<string, any>;
}

// Global Application State
export const AppState: AppStateShape = {
    currentUser: null,
    currentPage: 'login-page',
    currentSection: 'overview',
    currentYear: new Date().getFullYear(),
    currentTaskFilter: 'all',

    // Data
    bills: [],
    dues: {},
    transactions: [] as any[],
    maintenance: [] as any[],
    tasks: [] as any[],
    apartments: [],
    decisions: [] as any[],
    settings: { monthlyDueAmount: 500 },

    // Charts
    charts: {}
};
